module.exports = __webpack_public_path__ + "static/media/83.31843810.jpg";